import { EmailTemplate } from '../../types';

export enum IndLLPIncorporationTaskGroups {
  COMPANY_FORMATION_DETAILS = 'COMPANY_FORMATION_DETAILS',
  NAME_RESERVATION = 'NAME_RESERVATION',
  INCORPORATION_FILING = 'INCORPORATION_FILING',
  LLP_DEED_FILING = 'LLP_DEED_FILING',
  BANK_ACCOUNT_CREATION = 'BANK_ACCOUNT_CREATION',
}

export enum IndLLPIncorporationTasks {
  FILL_CORPORATION_DETAILS = 'FILL_CORPORATION_DETAILS',
  REVIEW_CORPORATION_DETAILS = 'REVIEW_CORPORATION_DETAILS',
  COMPLETE_MCA_NAME_RESERVATION = 'COMPLETE_MCA_NAME_RESERVATION',
  UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION = 'UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION',
  SEND_EMAIL_UPDATE = 'SEND_EMAIL_UPDATE',
  INCORPORATION_DOCUMENT_PREPARATION = 'INCORPORATION_DOCUMENT_PREPARATION',
  CLIENT_UPLOAD_SIGNED_DOCUMENT = 'CLIENT_UPLOAD_SIGNED_DOCUMENT',
  FILING_SUBMITTED_TO_MCA = 'FILING_SUBMITTED_TO_MCA',
  CLIENT_UPLOAD_CERT_OF_INCORP = 'CLIENT_UPLOAD_CERT_OF_INCORP',
  CLIENT_UPLOAD_PAN = 'CLIENT_UPLOAD_PAN',
  CLIENT_UPLOAD_TAN = 'CLIENT_UPLOAD_TAN',
  AGENT_UPLOAD_AOA = 'AGENT_UPLOAD_AOA',
  AGENT_UPLOAD_MOA = 'AGENT_UPLOAD_MOA',
  SOURCING_STAMP_PAPER = 'SOURCING_STAMP_PAPER',
  UPLOAD_LLP_DEED = 'UPLOAD_LLP_DEED',
  UPLOAD_SIGNED_LLP_DEED = 'UPLOAD_SIGNED_LLP_DEED',
  LLP_DEED_FILING_SUBMITTED = 'LLP_DEED_FILING_SUBMITTED',
  UPLOAD_APPROVED_LLP_DEED = 'UPLOAD_APPROVED_LLP_DEED',
  CLIENT_ADD_BANK_ACCOUNT = 'CLIENT_ADD_BANK_ACCOUNT',
}

export const IND_LLP_TASK_GROUP_TO_EMAIL_MAP: Record<
  IndLLPIncorporationTaskGroups,
  EmailTemplate | null
> = {
  [IndLLPIncorporationTaskGroups.COMPANY_FORMATION_DETAILS]: null,
  [IndLLPIncorporationTaskGroups.NAME_RESERVATION]: {
    body: `Hi,

Congratulations! We’ve received approval of your LLP name reservation from the Ministry of Corporate Affairs. Your approval letter has been uploaded to the Commenda dashboard. 

The team is now preparing your incorporation documents, this usually takes a day. These will need your signatures before they are filed. We will post an update once the documents are ready for your signature.`,
    subject: 'LLP Name reserved',
  },
  [IndLLPIncorporationTaskGroups.INCORPORATION_FILING]: {
    body: `Hi,

Congratulations! We’ve received confirmation of your LLP Incorporation documents from the Ministry of Corporate Affairs. Request you to upload them to the Commenda dashboard.

The next step is to procure your stamp paper and ready your LLP deed. We will be sharing this with you shortly.`,
    subject: 'LLP Incorporation Approved',
  },
  [IndLLPIncorporationTaskGroups.LLP_DEED_FILING]: {
    body: `Hi,
    
I'm pleased to inform you that your LLP Deed filing has been approved. This marks the final step in your LLP incorporation process.

You can now proceed with opening your business bank account for the LLP, sharing a list of partner bank contacts below. We recommend getting in touch with the partner to find a bank that best suits your business needs.

Yatin from HSBC - tel:+918588953747
Rishabh from HSBC - tel:+919019987737
Pramod from Standard Chartered - tel:+919284382240
Devansh from Standard Chartered - tel:+919833475050

Have an amazing day!
Team Commenda`,
    subject: 'LLP Deed approved',
  },
  [IndLLPIncorporationTaskGroups.BANK_ACCOUNT_CREATION]: null,
};
